<script>
    import NavLinks from "../molecules/NavLinks.svelte";
</script>

<header>
    <NavLinks />
</header>